//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoMultiplaEscolha',
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  props: {
    value: {
      type: [Array],
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        const selecaoAtual = alterado || [];
        this.objetoInterno = [...selecaoAtual];
      },
    },
  },
  data() {
    return {
      itens: [],
      objetoInterno: null,
      textoItem: null,
      valorItem: null,

      rules: {
        requiredNome: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const objeto = this.objetoInterno || [];

          return (objeto && objeto.length && objeto.length > 0) || msg;
        },
      },
    };
  },
  methods: {
    carregarItens() {
      const { desAtributos } = this.metadados;
      if (!desAtributos) {
        throw new Error('DesAtributos não pode ser null!');
      }

      const { textoItem, valorItem, lista } = desAtributos;
      if (textoItem) {
        this.textoItem = textoItem;
        this.valorItem = valorItem;
        this.itens = lista;
      } else {
        this.textoItem = 'texto';
        this.valorItem = 'valor';

        this.itens = lista.map((item) => {
          const formatado = {};
          formatado[this.textoItem] = item;
          formatado[this.valorItem] = item;
          return formatado;
        });
      }
    },
  },
  mounted() {
    this.carregarItens();
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoMultiplaEscolha.vue?vue&type=script&lang=js&